import './DailyOverviewChart.css'
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';
import StatusBadge from './StatusBadge';

Chart.register(ArcElement, Tooltip, Legend);

const EmptyCard = () => {
    return(
        <div className="empty-card ">
        <div className="metric-header">
            <h2>Empty card title</h2>
            <StatusBadge status="todo" label="To do" />
        </div>
        </div>
    );
};

export default EmptyCard;